import {delegateEvent} from "../utils/event.delegator";
import * as Optional from "optional-js";
import i18n from 'l10n';
import Handlebars from 'handlebars';
import BaseView from 'js/views/subscribers.base.view';
import RowView from 'js/views/subscriber.select.listgroup.row.view';
import InnerView from 'js/views/group.select.tile.view';
import MyModel from 'js/models/subscriber.groups.model';
import SubscribersCollection from 'js/models/subscribers.collection';
import GroupsCollection from 'js/models/groups.collection';
import Template from 'js/templates/selection.hbs';
import dhtmlx from 'dhtmlxAdapter';
import {_, Backbone} from "backboneAdapter";
import gMaps from 'gMaps';
import {domain, el, on, template} from "../adapters/backbone-decorators";

var Parser = require('tellody').parser;

const criteriaExpressionsTemplate = Handlebars.compile(require("js/templates/criteria.expressions.hbs"));
require('interfaceAdapter');
require('metroHelpers');
require('gMaps');

@el("#selection")
@domain('.page')
@template(Template)
class SelectionView extends BaseView {

    @on('keyup #contacts-container .searchbox')
    doContactSearch() {
        super.dosearch();
    }

    constructor(options) {
        super(options);
        this.postpaid = options.postpaid === "true" || options.postpaid === true;
        this.inMsgConfigContactsSearch = true;
        this.inGroupSearch = false;
        this.totalGroupsLength = 0;
        this.CCview = options.CCview;
        this.campaignChannel = options.campaignChannel;

        this.SubscriberView = RowView;

        this.subscribersCollection = new SubscribersCollection();

        this.GroupView = InnerView;

        this.groupsCollection = new GroupsCollection();
        this.groupsCollection.bind("reset add remove", this.renderGroupsCollection, this);

        this.CCview.setContactsExpanded(_.bind(this.contactsExpanded, this));
    }

    delegateEvents(events) {
        this.cid = 'add-dialog';
        Backbone.View.prototype.delegateEvents.call(this, events);
    }

    async load() {
        try {
            this.model = new MyModel();
            var options = {isCalledFromSelectionView: true};
            await super.load(options);
            await this.groupsCollection.fetch();

            this.render(this);
        } catch (e) {
            console.error(e);
            $.Notify.error(i18n.t("subscriber.nogroups"));
        }

    }

    render() {
        this.model.set("campaignId", this.CCview.model.get("campaignId"));
        this.model.set("postpaid", this.postpaid);
        this.model.set("startDate", this.CCview.model.get("startDate"));
        this.model.set("campaignStatus", this.CCview.model.get("campaignStatus"));
        this.model.set("campaignTemplateType", this.CCview.model.get("campaignTemplateType"));
        this.renderView();
        this.renderCollection();
    }

    renderCollection() {
        this.fillInGroupsCollection();
    }

    async fillInGroupsCollection() {

        $("#grouptiles").empty(); //empty the container div to avoid duplicates

        const groupIds = this.groupsCollection.map(model => model.get("id"));
        const queryGroups = this.groupsCollection.filter(model => (model.get("query") && model.get("query") !== ""))
            .map(model => [model.get(model.idAttribute), model.get("query")]);

        const getGroupInfo = type => $.ajaxDefaultQ({
            url: `/CampaignCloud/Group/${type}`,
            type: 'GET',
            contentType: 'application/json',
            traditional: true,
            data: {groupIds},
            dataType: 'json'
        });

        if (groupIds.length > 0) {
            try {
                this.blockedCount = await getGroupInfo("blockedCount");

                _.forEach(this.blockedCount, ([id, blockedCount]) =>
                    Optional.ofNullable(this.groupsCollection.find(model => model.get(model.idAttribute) === id))
                        .ifPresent(model => model.set("blockedCount", blockedCount)));

                this.emailBounced = await getGroupInfo("emailBounced");

                _.forEach(this.emailBounced,
                    ([id, emailBounced]) => Optional.ofNullable(this.groupsCollection
                        .find(model => model.get(model.idAttribute) === id))
                        .ifPresent(model => model.set("emailBounced", emailBounced)));

                this.smsBounced = await getGroupInfo("smsBounced");

                _.forEach(this.smsBounced, ([id, smsBounced]) =>
                    Optional.ofNullable(this.groupsCollection.find(model => model.get(model.idAttribute) === id))
                        .ifPresent(model => model.set("smsBounced", smsBounced)));


                if (queryGroups.length > 0) {

                    const queryCountResults = await $.ajaxDefaultQ({
                        url: "/CampaignCloud/Subscription/CountByCriterion/many",
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(queryGroups)
                    });
                    _.forEach(queryCountResults, ([id, size]) =>
                        this.groupsCollection.find(model => model.get("id") === id).set("size", size));

                    const counter = this.groupsCollection.countBy(model =>
                        (model.get("id") === 1 || (model.get("size") > (model.get("bouncedCount") || 0))));
                    this.groupsCollection.each(model => this.renderModel(model));
                    this.editSearchBox(counter, this);
                }
                this.postpaidElementExistence();
            } catch (e) {
                console.error(e);
            }
        } else {
            $("#groupsLength").text('0');
            this.hideGroupsSearchBox();
            this.showNoGroupsToSearchMessage();
        }
    }

    editSearchBox(counter, self) {
        if (counter > 0) {
            $("#groupsLength").text(counter - 1); // -1 because of the BLOCKED CONTACTS group
            if (!this.inGroupSearch) {
                self.totalGroupsLength = counter - 1;
            }
            if (!this.totalGroupsLength) {
                setTimeout(function () {
                    self.hideGroupsSearchBox();
                    self.showNoGroupsToSearchMessage();
                }, 0);

            } else {
                setTimeout(function () {
                    self.hideNoGroupsToSearchMessage();
                    self.showGroupsSearchBox();
                }, 0);
            }
        } else {
            $("#groupsLength").text(counter);
        }
    }

    postpaidElementExistence() {
        if (!this.postpaid) {
            var elementExists = document.getElementById("geographic-groups-container");
            if (!elementExists) {
                console.info("does not exist");
            } else {
                console.info("does exist");
                this.fillInGeographicGroups();
            }
        }
    }

    modelRendering(model, el) {
        var view = new this.SubscriberView({model, CCview: this.CCview});
        delegateEvent(view, this, "ContactDeselected");
        delegateEvent(view, this, "ContactSelected");
        view.render();
        var elInner = view.el;
        const $el = $(el);
        $el.html('');
        $el.append(elInner);
    }

    renderGroupsCollection() {
        var self = this;
        self.model.set("groupsLength", self.groupsCollection.length - 1);
    }

    showNoGroupsToSearchMessage() {
        this.$("#nogroupssearchmsg").show();
    }

    hideNoGroupsToSearchMessage() {
        this.$("#nogroupssearchmsg").hide();
    }

    showGroupsSearchBox() {
        this.$("#groupsinmgsconfigsearchbox").show();
    }

    hideGroupsSearchBox() {
        this.$("#groupsinmgsconfigsearchbox").hide();
    }

    renderModel(model, scroll) {
        var view = this.groupView = new this.GroupView({model: model, CCview: this.CCview});
        delegateEvent(view, this, "GroupSelected");
        delegateEvent(view, this, "GroupDeselected");
        view.render();
        var el = view.el;
        this.$el.find('#grouptiles').append(el);
        if (scroll) {
            el.scrollIntoView();
        }
    }

    newSubscriberView(model) {
        model.set("postpaid", this.postpaid);
        const view = new this.SubscriberView({model: model, CCview: this.CCview});
        delegateEvent(view, this, "ContactDeselected");
        delegateEvent(view, this, "ContactSelected");
        return view;
    }

    @on('keyup #groups-container .searchbox')
    doGroupSearch() {
        var text = this.$el.find('#groups-container .searchbox').val().toLowerCase();
        if (text.length > 0) {
            var searchresults = this.groupsCollection.filter(m => m.myText().indexOf(text) !== -1);

            for (var i = 0; i < this.groupsCollection.models.length; i++) {
                var model = this.groupsCollection.models[i];
                if (searchresults.indexOf(model) !== -1) {
                    this.$el.find(`#group-${model.get("id")}`).show();
                } else {
                    this.$el.find(`#group-${model.get("id")}`).hide();
                }
            }
            this.inGroupSearch = true;
        } else {
            this.inGroupSearch = false;
            this.$el.find('.tile').show();
        }
    }

    @on('click .selection-tab-btn')
    changeVisibleTargetingTab(evt) {
        const $clickedTabButton = $(evt.currentTarget);
        const targetId = $clickedTabButton.data("id");
        const targetTags = $clickedTabButton.data("tags");

        const $currentActiveTabButton = $(".selection-tab-btn.active");
        const $currentActiveTab = $(".selection-tab.active");
        const $currentTagsContainer = $(".tags-container .tag-container.active");

        $currentActiveTabButton.removeClass("bg-funkyOrange fg-white active").addClass("bg-lightGray fg-black");
        $clickedTabButton.removeClass("bg-lightGray fg-black").addClass("bg-funkyOrange fg-white active");

        $currentActiveTab.removeClass("active");
        $currentTagsContainer.removeClass("active");

        $("#"+ targetId).addClass("active");
        $(".tags-container").find(".tag-container."+ targetTags +"-tags-container").addClass("active");
    }

    @on('click #successBtn')
    async selectAllContacts() {
        var self = this;
        var contactIds = this.CCview.model.get("contactIds");
        var includedGroups = this.CCview.model.get("includedGroups");

        $.each(contactIds, function (index, subId) {
            $(`#contact-item-${subId}`).removeClass("selected");
        });
        $.each(includedGroups, function (index, groupId) {
            if(groupId.indexOf("q:in bounds") > -1) { //geo areas
                const $deleteIcon = $('[data-pseudoid="'+ groupId +'"]');
                const indx = $deleteIcon.data("index");

                self.trigger("GroupDeselected", `Geo-${indx}`);
            }else {
                const selector = groupId.toLowerCase().replace("group", "#group-")
                const $groupTile = $("#grouptiles").find(selector);
                $groupTile.removeClass("selected");
            }
        });

        contactIds = []; //empty arrays of contacts and groups and save them
        includedGroups = [];

        this.CCview.model.set("contactIds", contactIds);
        this.CCview.model.set("includedGroups", includedGroups);

        try {

            const {outcome: cidSaveOutcome} = await this.CCview.model.saveAttribute("contactIds", contactIds);
            if ("OK" !== cidSaveOutcome) {
                this.render(); //restore original values
                console.info("Not good");
            }

            const {outcome: igSaveOutcome} = await this.CCview.model.saveAttribute("includedGroups", includedGroups);
            if ("OK" !== igSaveOutcome) {
                this.render(); //restore original values
                console.info("Not good");
            } else {
                this.CCview.refreshTargetingSize();
            }
            this.trigger("selectAllContactsClicked");
        } catch (e) {
            console.error(e);
        }
    }

    fillInGeographicGroups() {
        if (this.postpaid) {
            return;
        }
        this.maps = {};
        let groups = this.CCview.model.get("includedGroups");
        let ccid = this.CCview.model.get("id");
        const [geoGroups, rest] = _.partition(groups, group => group.indexOf("q:in bounds") !== -1);
        const queryGroups = rest.filter(group => group.indexOf("q:") !== -1);
        geoGroups.forEach(async (group, index) => {
            var criterion = group.substring(2, group.length);

            try {
                const count = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Subscription/${this.campaignChannel}/CountByGeoCriterion`,
                    type: "GET",
                    data: {criterion: criterion},
                    dataType: "json"
                });
                const geoGroupTemplate = Handlebars.compile(require("js/templates/geo.group.hbs"));
                const $el = geoGroupTemplate({
                    campaignChannel: this.campaignChannel,
                    index,
                    group,
                    ccid,
                    count
                });
                var $nogeoareasmsg = $("#nogeoareasmsg");
                if (!this.isHidden($nogeoareasmsg)) {
                    $nogeoareasmsg.hide();
                }
                $("#geographic-groups-container").append($el);

                var rx = new RegExp('^q\\:in bounds\\((.*),(.*),(.*),(.*)\\)$');
                var res = rx.exec(group); //Ex: q:in bounds(2.45,4.78,3,42)
                if (res) {
                    var south = parseFloat(res[1]);
                    var west = parseFloat(res[2]);
                    var north = parseFloat(res[3]);
                    var east = parseFloat(res[4]);
                    var bounds = {south: south, west: west, north: north, east: east};
                    var map = new gMaps.Map($(`#map-${index}`)[0], {
                        center: new gMaps.LatLng((south + north) / 2, (west + east) / 2),
                        zoom: 8,
                        mapTypeId: gMaps.MapTypeId.ROADMAP,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false
                    });
                    map.fitBounds(bounds);
                    var rectangle = new gMaps.Rectangle({
                        bounds: bounds,
                        editable: false,
                        draggable: false
                    });

                    rectangle.setMap(map);

                    this.maps[group] = map;
                }
            } catch (e) {
                console.info("An error occurred!");
                console.info(e);
            }

        });

        queryGroups.forEach((group, index) => {
            const query = group.substring(2);
            const parsedQuery = Parser.parse(query); //todo check it

            const $el = $(criteriaExpressionsTemplate({index, group}));
            const $crExp = $el.find(`#criteriaExpression-${index}`);
            $crExp.text(query);
            const $noCriteriaExpressions = $("#noCriteriaExpressions");

            if (!this.isHidden($noCriteriaExpressions)) {
                $noCriteriaExpressions.hide();
            }
            $("#criteria-expressions-container").append($el);
            this.CCview.makeEditable(0, $crExp, this.CCview);
        });
    }

    contactsExpanded() {
        if (!this.postpaid) {
            this.getActiveAddon();
        }
        console.log('Contacts expanded');
        $(window).trigger("resize");
        var self = this;
        _.forEach(_.pairs(self.maps), function (pair) {
            var group = pair[0];
            var map = pair[1];

            gMaps.event.trigger(map, 'resize');

            var rx = new RegExp('^q\\:in bounds\\((.*),(.*),(.*),(.*)\\)$');
            var res = rx.exec(group); //Ex: q:in bounds(2.45,4.78,3,42)
            if (res) {
                var south = parseFloat(res[1]);
                var west = parseFloat(res[2]);
                var north = parseFloat(res[3]);
                var east = parseFloat(res[4]);

                var center = new gMaps.LatLng((south + north) / 2, (west + east) / 2);
                map.setCenter(center);

                var bounds = {south: south, west: west, north: north, east: east};
                map.fitBounds(bounds);
            }
        });
    }

    @on('click #addNewGeogroup')
    addNewGeoGroup() {
        if (this.postpaid) {
            return;
        }
        var ccid = this.CCview.model.get("id");
        location.href = `/CampaignCloud/cloudui/home/ContactMap.htm#${ccid}/${this.campaignChannel}/none`;
    }

    @on('click #addNewCriteriaExpression')
    async addNewCriteriaExpression() {
        const attr = 'includedGroups';
        const criteriaString = 'q:true';
        const existingGroups = this.CCview.model.get(attr).concat(criteriaString);
        this.CCview.model.set(attr, existingGroups);
        const model = await this.CCview.model.save(self.CCview.model.attributes);
        const index = model.get('includedGroups').length - 1;
        const $el = $(criteriaExpressionsTemplate({index}));
        const query = model.get('includedGroups')[index];

        $($el).find(`#criteriaExpression-${index}`).text(query.substring(2));
        $($el).find("[data-pseudoId]").attr('data-pseudoid', query);

        const $noCriteriaExpressions = $("#noCriteriaExpressions");

        if (!self.isHidden($noCriteriaExpressions)) {
            $noCriteriaExpressions.hide();
        }

        $("#criteria-expressions-container").append($el);
        self.CCview.refreshTargetingSize();
        self.CCview.makeEditable(0, $($el).find(`#criteriaExpression-${index}`), self.CCview);
        $.Notify.show(i18n.t('message.addNewCriteriaExpressionNotification'));
    }

    isHidden(element) {
        return (element.offsetParent === null);
    }

    @on('click .removeGeoGroup')
    removeGeoGroup(ev) {
        if (this.postpaid) {
            return;
        }
        var pseudoId = $(ev.currentTarget).attr("data-pseudoId");
        var index;
        this.CCview.model.get('includedGroups').find(function (group, indexTemp) {
            if (group === pseudoId) {
                index = indexTemp;
                return true;
            } else {
                return false;
            }
        });
        var self = this;

        dhtmlx.modalbox({
            title: i18n.t("survey.confirmdeletion"),
            text: i18n.t("survey.areyousuretodelete"),
            buttons: [i18n.t("message.yes"), i18n.t("message.no")],
            callback(result) {
                if (result === "0") {
                    $.ajaxDefaultQ({
                        url: `/CampaignCloud/Config/${self.CCview.model.get("id")}/includedGroups/${index}`,
                        type: "delete",
                        dataType: "json"
                    }).done(function () {
                        var isCriteriaExpression = $(ev.currentTarget).hasClass("criteriaExpression");
                        if (isCriteriaExpression) {
                            $(`#criteriaExpression-${index}`).parent().remove();
                        } else {
                            const groupIndex = $(ev.currentTarget).attr("data-index");
                            $(`#geogroup-${groupIndex}`).remove();
                            self.trigger("GroupDeselected", `Geo-${groupIndex}`);
                        }
                        delete self.maps[pseudoId];
                        var includedGroups = self.CCview.model.get("includedGroups");
                        var i = includedGroups.indexOf(pseudoId);
                        if (i !== -1) {
                            includedGroups.splice(i, 1);
                        }
                        self.CCview.refreshTargetingSize();
                        var regex = new RegExp(/^(q:in bounds).*$/);
                        var areThereAnyGeoGroups;
                        includedGroups.filter(function (group) {
                            if (regex.test(group)) {
                                areThereAnyGeoGroups = true;
                                return true;
                            } else {
                                return false;
                            }
                        });
                        if (!areThereAnyGeoGroups) {
                            $("#nogeoareasmsg").show();
                        }
                        if (isCriteriaExpression) {
                            $.Notify.show(i18n.t("message.removeCriteriaExpressionNotification"));
                        } else {
                            $.Notify.show(i18n.t("message.removeGeoGroupNotification"));
                        }
                    }).fail(function (re) {
                        console.info("An error occurred!");
                        console.error(re);
                    });
                }
            }
        });
    }

    getActiveAddon() {
        if (this.postpaid) {
            return;
        }
        $.ajaxDefaultQ({
            url: '/CampaignCloud/CreditsController/getActiveAddon',
            dataType: "json"
        }).done(function (resp) {
            if (resp.outcome === "OK") {
                $("#geographic-groups-container").show();
                $("#noactiveaddon").hide();
            } else { // "NOT_FOUND"
                $("#noactiveaddon").show();
                $("#geographic-groups-container").hide();
                $("#nogeoareasmsg").hide();
                $("#addNewGeogroup").hide();
            }
        }).fail(function (resp) {
            console.error(`Error: ${resp}`);
        });
    }
}

export default SelectionView;
